import { connect } from 'react-redux'
import pick from 'lodash/pick'

import { loadQAWorkOrders } from '../../actions/qa-work-orders'

import QAWorkOrders from '../../components/qa-work-orders/qa-work-orders'

function mapStateToProps (state, ownProps) {
  const qaWorkOrders = pick(state.qaWorkOrders, state.pagination.qaWorkOrders.ids)

  return {
    qaWorkOrders,
    hasNextPage: !!state.pagination.qaWorkOrders.nextPageUrl
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(loadQAWorkOrders())

  return {
    onLoadNextPage () {
      dispatch(loadQAWorkOrders(true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QAWorkOrders)



// WEBPACK FOOTER //
// ./src/containers/qa-work-orders/qa-work-orders-container.js